export const CustomerLocationType = {
  RECEIVE: 1,
  RETURN_RESULT: 2,
  LEAD_TIMES: 3,
  SCHEDULES: 4,
};
export const mapOptionObjectToArray = object => {
  const objectValue = object && Object.keys(object);

  return objectValue?.map(item => ({
    label: object?.[item],
    value: item,
  }));
};
